import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Card, Btn } from "@/components/common";
import { MONTHS, pct, num } from "./helpers";
import { SEASON_CLR } from "./Charts";

const SL = { alta: "Alta", media: "Media", bassa: "Bassa" };
const init = (rows) => Object.fromEntries(rows.map((r) => [r.month, { weight: r.weight_set ? r.weight : "", occ_est: r.occ_est_set ? r.occ_est : "" }]));

export default function MonthParams({ d, onSaved }) {
  const [f, setF] = useState(() => init(d.rows));
  useEffect(() => { setF(init(d.rows)); }, [d.rows]);
  const set = (m, k, v) => setF({ ...f, [m]: { ...f[m], [k]: v } });
  const save = async () => {
    const n = (v) => (v === "" || v == null ? null : Number(v));
    try {
      await api.put(`/previsionale/${d.year}/month-params`, { months: Object.fromEntries(Object.entries(f).map(([m, x]) => [m, { weight: n(x.weight), occ_est: n(x.occ_est) }])) });
      toast.success("Pesi e occupazioni salvati");
      onSaved();
    } catch (e) { toast.error("Valori non validi (peso 0–10, occupazione 0–100)"); }
  };
  const inp = "w-16 text-right px-1.5 py-1 rounded border border-slate-300";
  return (
    <Card className="p-4" data-testid="pv-month-params">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Stagioni, pesi e occupazioni stimate {d.year}</div>
      <p className="text-[11px] text-slate-400 mb-2">Vuoto = valore predefinito (grigio). L'occupazione stimata vale nei mesi con meno di 10 notti confermate e senza storico.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-xs min-w-[520px]">
          <thead><tr className="text-[10px] uppercase text-slate-500 border-b border-slate-200 text-left">
            <th className="py-1.5">Mese</th><th>Stagione</th><th>Stato</th><th className="text-right">Peso ×</th><th className="text-right">Occ. stimata %</th><th className="text-right">Confermate</th><th className="text-right">Occ. prevista</th>
          </tr></thead>
          <tbody>
            {d.rows.map((r, i) => (
              <tr key={r.month} className="border-b border-slate-100" data-testid={`pv-mp-row-${r.month}`}>
                <td className="py-1 font-semibold">{MONTHS[i]}</td>
                <td className="font-semibold" style={{ color: SEASON_CLR[r.season] }}>{SL[r.season]}</td>
                <td className="text-[10px]">{r.closed ? <span className="text-rose-600 font-semibold">chiusa</span> : r.anomalo ? <span className="text-violet-600 font-semibold">anomalo</span> : r.state === "non_operativo" ? "—" : ""}</td>
                <td className="text-right"><input data-testid={`pv-mp-weight-${r.month}`} type="number" step="0.1" value={f[r.month]?.weight ?? ""} placeholder={String(r.weight_default ?? "")} onChange={(e) => set(r.month, "weight", e.target.value)} className={inp} /></td>
                <td className="text-right"><input data-testid={`pv-mp-occ-${r.month}`} type="number" value={f[r.month]?.occ_est ?? ""} placeholder={String(r.occ_est_default ?? "")} onChange={(e) => set(r.month, "occ_est", e.target.value)} className={inp} /></td>
                <td className="text-right tabular text-slate-500">{num(r.nights_conf)}</td>
                <td className="text-right tabular">{pct(r.occ_prev)}{r.manual_est && <span className="text-[10px] text-amber-600"> stima</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end mt-2"><Btn data-testid="pv-mp-save" onClick={save}>Salva pesi e occupazioni</Btn></div>
    </Card>
  );
}
